import React from 'react';
import QuickSearch from './QuickSearch';

// La pagina /cerca riusa la funzione di ricerca-per-numero (QuickSearch),
// la stessa richiamata dalla lente nell'header.
export default function CercaPage() {
  return <QuickSearch />;
}
